import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { EntryPoints } from './components/entry-points';
export var CnEntryPoints = withI18n(EntryPoints, { locale: locale });
